module.exports = __webpack_public_path__ + "img/A58A1337.d978c2a0.jpg";